import * as React from 'react';
import SVGIcon from '../SVGIcon';

interface Props {
  className?: string;
  color?: string;
}

const FilterIcon: React.FC<Props> = ({ className, color = 'currentColor' }) => {
  return (
    <SVGIcon viewBox="0 0 24 24" width="24" height="24" fill="none" className={className}>
      <path
        d="M20 7h-9"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 17H5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="17"
        cy="17"
        r="3"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="7"
        cy="7"
        r="3"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVGIcon>
  );
};

export default FilterIcon;
